import React from 'react';
import RcViewer from '@hanyk/rc-viewer';

interface Props {
  address: string;
  name: string;
}

class PictureView extends React.Component<Props> {

  render() {
    const { address } = this.props;
    return (
      <RcViewer>
        <img src={address} alt={name} style={{ maxHeight: 200}} />
      </RcViewer>
    )
  }
}

export default PictureView